<p-toast position="top-right"></p-toast>

<app-loader></app-loader>

<mat-toolbar
  id="main-toolbar"
  color="primary"
  class="primary-mat-toolbar"
  [ngClass]="getBannerClass()"
  *ngIf="!viewingUnauthenticatedRoute"
>
  <div class="titleView">
    <button
      *ngIf="accountService.hasValidRole()"
      class="menu-icon"
      mat-button
      data-testid="nav-menu-button"
      matTooltip="Click to toggle menu options"
      (click)="drawer.toggle()"
    >
      <mat-icon inline="true">menu</mat-icon>
    </button>

    <button
      id="Home"
      class="home-icon"
      data-testid="nav-home-button"
      matTooltip="Click to return to experiments"
      [matTooltipDisabled]="isTitlebarToolTipDisabled"
      mat-button
      (click)="goHome()"
    >
      <mat-icon id="HomeIcon">home</mat-icon> <span> {{ titleBarName }}</span>
      <span *ngIf="!isProduction"> - {{ environmentName }}</span>
    </button>
  </div>

  <div style="text-align: center">
    <div *ngIf="currentExperiment" class="experiment-header">
      <span class="experiment-name-header">
        {{ currentExperiment.name }}&nbsp;
        <span *ngIf="currentExperiment.source == ExperimentSource.LabPartner"
          >({{ currentExperiment.experimentId | experimentFormat: currentExperiment.type }})</span
        >

        <!-- Image Capture -->
        <ng-container *ngIf="currentExperiment.source == ExperimentSource.ImageCapture">
          <span>({{ currentExperiment.experimentId | icExperimentFormat }})</span>
          <span>&nbsp; - Round &nbsp;</span>

          <ng-container *ngIf="icRoundService.currentRound$ | async as currentRound">
            <ng-container *ngIf="icRoundService.lastRound$ | async as lastRound">
              <span *ngIf="lastRound == 1"> 01 </span>
              <select
                name="selectedRound"
                id="selectedRound"
                class="round-select"
                data-testid="nav-round-select"
                *ngIf="lastRound > 1"
                [ngModel]="currentRound"
                (change)="onChangeRound($event)"
              >
                <option [value]="round" *ngFor="let round of getRounds(lastRound)">
                  0{{ round }}
                </option>
              </select>
            </ng-container>
          </ng-container>
        </ng-container>

        <button
          mat-icon-button
          class="experiment-edit-icon"
          data-testid="nav-experiment-edit-button"
          (click)="onEdit()"
          matTooltip="{{
            (currentUser | canEditExperiment: currentRoles : currentExperiment)
              ? 'Edit the experiment'
              : 'View experiment settings'
          }}"
          [disabled]="
            !(
              currentRoles
              | hasAnyRoles: ['WRITER', 'READER', 'VIEWER'] : currentExperiment : 'IsAnyStatus'
            )
          "
        >
          <mat-icon>{{
            (currentUser | canEditExperiment: currentRoles : currentExperiment)
              ? 'edit'
              : 'info_outline'
          }}</mat-icon>
        </button>
        <app-note-display
          [experimentId]="currentExperiment.experimentId"
          [noteCount]="experimentNoteCounts && experimentNoteCounts[currentExperiment.experimentId]"
          [objectID]="currentExperiment.experimentId"
          [objectName]="'Experiment'"
          class="experiment-note"
        >
        </app-note-display>
        <button
          mat-icon-button
          *ngIf="(experimentAuditCount ?? 0) > 0"
          class="experiment-audit-icon"
          data-testid="nav-experiment-audit-button"
          [class.has-notes]="
            experimentNoteCounts && experimentNoteCounts[currentExperiment.experimentId] > 0
          "
          (click)="showAuditDialog(currentExperiment)"
          matTooltip="{{ experimentAuditCount }} change log records"
        >
          <mat-icon>receipt_long</mat-icon>
        </button>
        <button
          *ngIf="
            !currentExperiment.isArchived &&
            appState.GetCurrentExperiment().source == ExperimentSource.LabPartner
          "
          mat-icon-button
          class="experiment-clone-icon"
          data-testid="nav-experiment-clone-button"
          (click)="cloneExperiment(currentExperiment)"
          matTooltip="Clone experiment"
          [disabled]="
            !(currentRoles | hasAnyRoles: ['WRITER', 'READER'] : currentExperiment : 'IsAnyStatus')
          "
        >
          <mat-icon>add_circle</mat-icon>
        </button>
        <ng-container *ngIf="currentExperiment.source == ExperimentSource.LabPartner">
          <ng-container *ngIf="experimentPresenceService.users$ | async as experimentPresenceUsers">
            <ng-container *ngIf="getOtherExperimentUsers(experimentPresenceUsers) as otherExperimentUsers">
              <button
                mat-icon-button
                class="experiment-presence-icon"
                data-testid="nav-experiment-presence-button"
                [matMenuTriggerFor]="experimentPresenceMenu"
                [disabled]="(experimentPresenceService.status$ | async) !== 'connected'"
                [matTooltip]="
                  otherExperimentUsers.length === 0
                    ? 'No other users are active on this experiment'
                    : 'View users active on this experiment'
                "
                aria-label="Active experiment users"
              >
                <mat-icon
                  class="experiment-presence-status"
                  [class.experiment-presence-status--busy]="hasOtherExperimentWriter(experimentPresenceUsers)"
                  >circle</mat-icon
                >
              </button>
              <mat-menu #experimentPresenceMenu="matMenu" class="experiment-presence-menu">
                <section class="experiment-presence-panel" aria-label="Concurrent experiment users">
                  <div class="experiment-presence-panel__header">
                    <mat-icon>group</mat-icon>
                    <span>Concurrent users</span>
                    <span class="experiment-presence-panel__count">{{ otherExperimentUsers.length }}</span>
                  </div>
                  <div
                    *ngIf="otherExperimentUsers.length === 0"
                    class="experiment-presence-panel__empty"
                  >
                    <mat-icon>person</mat-icon>
                    <span>No other users are active</span>
                  </div>
                  <div
                    *ngFor="let presenceUser of otherExperimentUsers"
                    class="experiment-presence-panel__user"
                  >
                    <mat-icon class="experiment-presence-panel__user-icon">
                      {{ presenceUser.canWrite ? 'edit' : 'visibility' }}
                    </mat-icon>
                    <span class="experiment-presence-panel__user-details">
                      <span class="experiment-presence-panel__email">{{ presenceUser.email }}</span>
                      <span class="experiment-presence-panel__permission">
                        {{ presenceUser.canWrite ? 'Writer' : 'Read only' }}
                      </span>
                    </span>
                  </div>
                </section>
              </mat-menu>
            </ng-container>
          </ng-container>
        </ng-container>
      </span>
      <span
        id="status-bar"
        class="status-bar"
        *ngIf="appState.GetCurrentExperiment().source == ExperimentSource.LabPartner"
      >
        Created
        <mat-icon style="color: #1bff00">check_circle</mat-icon>
        | Details Generated
        <span
          *ngIf="
            appState.GetCurrentExperiment().status < 2;
            then thenBlockStatusUnchecked;
            else elseBlockStatusChecked
          "
        ></span>
        | Ready to Test
        <span
          *ngIf="
            appState.GetCurrentExperiment().status < 3;
            then thenBlockStatusUnchecked;
            else elseBlockStatusChecked
          "
        ></span>
        | Complete
        <span
          *ngIf="
            appState.GetCurrentExperiment().status < 4;
            then thenBlockStatusUnchecked;
            else elseBlockStatusChecked
          "
        ></span>
      </span>

      <!-- Image Capture Status -->
      <ng-container *ngIf="appState.GetCurrentExperiment().source == ExperimentSource.ImageCapture">
        <ng-container
          *ngIf="{ val: (icRoundService.isInLastRound$ | async) ?? false } as isInLastRound"
        >
          <span
            *ngIf="isInLastRound.val"
            [ngClass]="{ cancelled: appState.GetCurrentExperiment().isCancelled }"
            id="status-bar"
            class="status-bar"
          >
            Created
            <mat-icon class="checked" style="color: #1bff00">check_circle</mat-icon>
            | Ready
            <span
              *ngIf="
                appState.GetCurrentExperiment().status < 2;
                then thenBlockStatusUnchecked;
                else elseBlockStatusChecked
              "
            ></span>
            | InProgress
            <span
              *ngIf="
                appState.GetCurrentExperiment().status < 3;
                then thenBlockStatusUnchecked;
                else elseBlockStatusChecked
              "
            ></span>
            | Analyzing Images
            <span
              *ngIf="
                appState.GetCurrentExperiment().status < 4;
                then thenBlockStatusUnchecked;
                else elseBlockStatusChecked
              "
            ></span>
            | Complete
            <span
              *ngIf="
                appState.GetCurrentExperiment().status < 5;
                then thenBlockStatusUnchecked;
                else elseBlockStatusChecked
              "
            ></span>
            <div *ngIf="appState.GetCurrentExperiment().isCancelled">
              | Cancelled
              <div class="cancelled">
                <mat-icon>cancel</mat-icon>
              </div>
            </div>
          </span>
          <span
            *ngIf="!isInLastRound.val"
            [ngClass]="{ cancelled: appState.GetCurrentExperiment().isCancelled }"
            id="status-bar"
            class="status-bar"
          >
            Created
            <mat-icon class="checked" style="color: #1bff00">check_circle</mat-icon>
            | Ready
            <mat-icon class="checked" style="color: #1bff00">check_circle</mat-icon>
            | InProgress
            <mat-icon class="checked" style="color: #1bff00">check_circle</mat-icon>
            | Analyzing Images
            <mat-icon class="checked" style="color: #1bff00">check_circle</mat-icon>
            | Complete
            <mat-icon class="checked" style="color: #1bff00">check_circle</mat-icon>
            <div *ngIf="appState.GetCurrentExperiment().isCancelled">
              | Cancelled
              <div class="cancelled">
                <mat-icon>cancel</mat-icon>
              </div>
            </div>
          </span>
        </ng-container>
      </ng-container>

      <ng-template #thenBlockStatusUnchecked>
        <mat-icon>radio_button_unchecked</mat-icon>
      </ng-template>

      <ng-template #elseBlockStatusChecked>
        <mat-icon class="checked" style="color: #1bff00">check_circle</mat-icon>
      </ng-template>
    </div>
  </div>

  <div class="navigation-items">
    <div>
      <button mat-icon-button data-testid="nav-help-menu-button" [matMenuTriggerFor]="helpMenu" matTooltip="Click for help menu">
        <mat-icon class="helpIcon">help_outline</mat-icon>
      </button>
      <mat-menu #helpMenu="matMenu">
        <div class="helpDropContent">
          <button mat-menu-item data-testid="nav-help-userguide-button" (click)="showInstructionVideo()">
            <mat-icon>ondemand_video</mat-icon>
            <span>User Guide Videos</span>
          </button>
          <button mat-menu-item data-testid="nav-help-support-button" (click)="showContactAndSupport()">
            <mat-icon>help</mat-icon>
            <span>Contact & Support</span>
          </button>
          <hr />
          <button mat-menu-item data-testid="nav-help-releasenotes-button" (click)="showReleaseNotes()">
            <mat-icon>history</mat-icon>
            <span>Release Notes</span>
          </button>
          <a mat-menu-item data-testid="nav-help-licenses-link" href="/3rdpartylicenses.txt" target="_blank">
            <mat-icon>workspace_premium</mat-icon>
            <span>Licenses</span>
          </a>
          <hr />
          <div class="helpVersion">{{ environmentName }} - v{{ appVersion }}</div>
        </div>
      </mat-menu>
    </div>
    <div *ngIf="!loginDisplay">
      <button mat-raised-button data-testid="nav-login-button" matTooltip="Click to log in" (click)="login()">Login</button>
    </div>
    <div *ngIf="loginDisplay">
      <button
        mat-icon-button
        data-testid="nav-profile-menu-button"
        [matMenuTriggerFor]="profileMenu"
        matTooltip="Click to log out / view privileges"
      >
        <mat-icon class="profileIcon">person_outline</mat-icon>
      </button>
      <mat-menu #profileMenu="matMenu">
        <div class="profileDropContent">
          <div>{{ displayName }}</div>
          <hr />

          <ng-container *ngIf="accountService.isLPUser()">
            <div *ngIf="!accountService.isViewer()">
              <div class="roleListItem">
                Admin<mat-icon
                  (click)="removeAdmin()"
                  *ngIf="accountService.isAdmin()"
                  class="check"
                  data-testid="nav-profile-removeadmin-icon"
                  >check</mat-icon
                >
              </div>
              <div class="roleListItem">
                Writer<mat-icon
                  (click)="removeWriter()"
                  *ngIf="accountService.isWriter()"
                  class="check"
                  >check</mat-icon
                >
              </div>
              <div class="roleListItem">
                Operator<mat-icon *ngIf="accountService.isReader()" class="check" data-testid="nav-profile-reader-icon">check</mat-icon>
              </div>
            </div>
            <div *ngIf="accountService.isViewer()">
              <div class="roleListItem">
                Admin<mat-icon
                  (click)="removeAdmin()"
                  *ngIf="accountService.isAdmin()"
                  class="check"
                  data-testid="nav-profile-removeadmin2-icon"
                  >check</mat-icon
                >
              </div>
              <div class="roleListItem">
                Writer<mat-icon
                  (click)="removeWriter()"
                  *ngIf="accountService.isWriter()"
                  class="check"
                  >check</mat-icon
                >
              </div>
              <div class="roleListItem">
                Operator<mat-icon
                  (click)="removeReader()"
                  *ngIf="accountService.isReader()"
                  class="check"
                  data-testid="nav-profile-removereader-icon"
                  >check</mat-icon
                >
              </div>
              <div class="roleListItem">
                Viewer<mat-icon *ngIf="accountService.isViewer()" class="check" data-testid="nav-profile-viewer-icon">check</mat-icon>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="accountService.isICUser()">
            <div>
              <div class="roleListItem">
                IC - Writer<mat-icon
                  (click)="removeICWriter()"
                  *ngIf="accountService.isICWriter()"
                  class="check"
                  data-testid="nav-profile-removeicwriter-icon"
                  >check</mat-icon
                >
              </div>
            </div>
          </ng-container>

          <hr />

          <!-- Test Mode User Switch Button -->
          <button *ngIf="environment.testMode" mat-menu-item data-testid="nav-profile-switchuser-button" (click)="showTestLoginDialog()">
            <mat-icon>swap_horiz</mat-icon>
            <span>Switch Test User</span>
          </button>

          <button mat-menu-item data-testid="nav-profile-logout-button" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </div>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>

<!-- <div id='print-header'>
  PRINTER HEADER
</div> -->
<mat-drawer-container class="sidenav-container" autosize>
  <mat-drawer #drawer class="sidenav-drawer" mode="side">
    <mat-nav-list class="sidenav-list" (click)="drawer.toggle()">
      <div class="navbutton-column">
        <ng-container *ngIf="accountService.isLPUser()">
          <button
            mat-button
            class="navbutton"
            data-testid="nav-labpartner-button"
            (click)="navigateLabpartnerRoute()"
            *ngIf="accountService.hasValidRole()"
          >
            Lab Partner
          </button>
          <button
            mat-button
            class="navbutton"
            data-testid="nav-savannaresults-button"
            (click)="navigateSavannaRoute()"
            *ngIf="accountService.hasValidRole() && (featureFlags$ | async)?.EnableSavanna"
          >
            Savanna Results
          </button>
          <button mat-button class="navbutton" data-testid="nav-resultsbundler-button" (click)="navigateBundlesRoute()">
            Results Bundler
          </button>
          <button
            mat-button
            class="navbutton"
            data-testid="nav-admin-button"
            (click)="navigateAdmin()"
            *ngIf="accountService.isAdmin() && (featureFlags$ | async)?.EnableDataInsightsPreview"
          >
            Admin
          </button>
        </ng-container>
        <ng-container *ngIf="accountService.isCAUser() && isCloudAnalysisEnabled(featureFlags$ | async)">
          <button
            mat-button
            class="navbutton"
            data-testid="nav-cloudanalysis-button"
            (click)="navigateCloudAnalysis()"
          >
            Cloud Analysis
          </button>
          <button
            mat-button
            class="navbutton navbutton-sub"
            data-testid="nav-cloudanalysis-admin-button"
            (click)="navigateCloudAnalysisAdmin()"
            *ngIf="accountService.isCAAdmin()"
          >
            Admin
          </button>
        </ng-container>
        <ng-container *ngIf="accountService.hasValidRole() && isBenchBuddyEnabled(featureFlags$ | async)">
          <button
            mat-button
            class="navbutton"
            data-testid="nav-benchbuddy-button"
            (click)="navigateBenchBuddy()"
          >
            Bench Buddy
          </button>
        </ng-container>
        <ng-container *ngIf="accountService.isICUser()">
          <button
            mat-button
            class="navbutton"
            data-testid="nav-imagecapture-button"
            (click)="navigateImageCapture()"
            *ngIf="accountService.hasValidRole() && (featureFlags$ | async)?.EnableImageCapture"
          >
            Image Capture
          </button>
        </ng-container>
      </div>
    </mat-nav-list>
  </mat-drawer>

  <div class="sidenav-content">
    <main>
      <div class="content" role="main">
        <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
        <router-outlet *ngIf="!isIframe"></router-outlet>
      </div>
    </main>
  </div>
</mat-drawer-container>
